exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".viewAllWrapper--5LWmm{display:flex;align-items:center;justify-content:center;border:1px solid #eee;border-radius:4px;padding:20px;height:100%;font-size:18px;color:#0088dc}.viewAllLink--3cpB5:focus,.viewAllLink--3cpB5:hover{text-decoration:none}", ""]);

// Exports
exports.locals = {
	"viewAllWrapper": "viewAllWrapper--5LWmm",
	"viewAllLink": "viewAllLink--3cpB5"
};